import { createContext, useReducer, useMemo } from 'react';
import { getEnvironment } from '../helpers/environment';
import { appReducer, getAppInitialState } from '../reducers/app';
import { mainReducer, getMainInitialState } from '../reducers/main';

export const getContext = () => {
    const environment = useMemo(() => getEnvironment(),[]);
    const mainInitialState = useMemo(() => getMainInitialState(),[]);
    const appInitialState = useMemo(() => getAppInitialState(),[]);
    
    const [ mainState, mainDispatch ] = useReducer(mainReducer, mainInitialState);
    const [ appState, appDispatch ] = useReducer(appReducer, appInitialState);
    
    const mainReducerValue = useMemo(() => ({
        state: mainState,
        dispatch: mainDispatch
    }), [mainState, mainDispatch]);

    const appReducerValue = useMemo(() => ({
        state: appState,
        dispatch: appDispatch
    }), [appState, appDispatch]);

    const contexto = useMemo(() => ({
        environment: environment,
        mainReducer: mainReducerValue,
        appReducer: appReducerValue
    }), [environment, mainReducerValue, appReducerValue]);

    return contexto;
}

export const MainContext = createContext(null);